module.exports = __webpack_public_path__ + "static/media/route_history_on.4e0b1964.png";